function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon/action/delete/enabled",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("line", {
  x1: 9,
  y1: 9,
  x2: 9,
  y2: 18,
  id: "Stroke-1",
  stroke: "#1B2559",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  x1: 13,
  y1: 9,
  x2: 13,
  y2: 18,
  id: "Stroke-2",
  stroke: "#1B2559",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-3",
  stroke: "#1B2559",
  strokeWidth: 2,
  strokeLinejoin: "round",
  points: "3 6 5 21 17 21 19 6"
}), /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: 5,
  x2: 21,
  y2: 5,
  id: "Stroke-5",
  stroke: "#1B2559",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M14,4 C14,2.343 12.657,1 11,1 C9.343,1 8,2.343 8,4",
  id: "Stroke-7",
  stroke: "#1B2559",
  strokeWidth: 2
}));

function SvgEnabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnabled);
export default __webpack_public_path__ + "static/media/enabled.a058fdfc.svg";
export { ForwardRef as ReactComponent };